<template>
<popup class="delete-gateway-popup" title="Deleting a gateway" medium @close="$emit('close')">
	<template v-slot:content>
		<p>Are you sure you would like to delete this gateway?
			<br>
			<b>{{userGateway?.name || ""}}</b>
		</p>

		<div class="alert_box orange">
			<inline-svg class="icon" :src="require('@/assets/img/alert_icon_yellow.svg')" />
			<span>
				<b>Before deleting this gateway:</b><br>
				Make sure no live funnels are using it to process payments.<br>
				Any funnel currently using it <b>will not be able to process payments</b>.<br>
				You can add multiple gateways of the same type to your account.
			</span>
		</div>
	</template>
	<template v-slot:actions>
		<v-button label="Keep gateway" border @click="$emit('close')" />
		<v-button label="Delete gateway" red border @click="$emit('done')"  />
	</template>
</popup>
</template>

<script>
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
export default {
	name: "delete-gateway-popup",
	components: {VButton, Popup},
	props:["userGateway"],

}
</script>

<style lang="scss" scoped>
.delete-gateway-popup {

}
.alert_box {
	span {
		line-height: 1.5;
		font-weight: 500;
	}
}
</style>
